import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssuePrisonIndustrialComplex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Prison industrial complex',
      description: 'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.',
      url: config.domain + config.routes.issuePrisonIndustrialComplex
    }
  }

  render() {
    return (
      <div styleName='page issue-pff'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Prison industrial complex</span>
            </h1>
            <h2 styleName='issue-top-headline'>
              Mass incarceration is a manifestation of racist policy
            </h2>
            <h3 styleName='issue-top-copy'>
              Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are invested in private prison operators and other high-risk companies</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    Mass incarceration is particularly devastating for poor communities, immigrants, people of color, and their families. For-profit firms have flooded money into prison and immigration jail infrastructure and services, and have used industry associations to lobby for harsher policing and longer sentencing, even for non-violent offenders. People who are incarcerated work for pennies per hour while their families pay exorbitant fees to keep them supplied with bare necessities. Powerful, private equity interests and corporations reap enormous profits from the militarization of the U.S.-Mexico border and the policing of immigration.
                  </p>
                  <p>
                    Asset managers like Vanguard are investing in economic systems of oppression and exploitation – and they’re using workers’ retirement plan savings to do so. Through Vanguard, the retirement plans of companies like Amazon and Comcast are investing hundreds of millions of dollars into private prison operators and other companies recommended for divestment by the <Link to={config.links.afscInvestigate} title='American Friends Service Committee state violence criteria' xstrong>American Friends Service Committee state violence criteria.</Link>
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Private prison operators
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Cities, counties, states, and the federal government sometimes contract with for-profit private contractors to operate prisons, jails, and immigration jails. Corporate retirement plans have hundreds of millions of dollars invested in private prison operators like U.S.-based GEO Group and CoreCivic, British company Serco, and French company Sodexo.
                    </p>
                    <p>
                      These private prison corporations spend substantial money on lobbying and campaign contributions to secure contracts and promote legislation that results in higher rates of incarceration. For many of these contracts, the companies are paid based upon how many beds are occupied in any given facility, incentivizing the company to support incarcerating more people.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#prisonindustrialcomplex'}
                        title='Companies: Prison industrial complex'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Exclude high-risk prison industrial complex companies from retirement plan default options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude companies with significant involvement in the prison industrial complex like private prison operators.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionDefaultSustainability}
                        title='Solution: Default to sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing the prison industrial complex.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
